import { Link, useNavigate } from "react-router-dom";
import { Bell, Info } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useFetch, fmtDate, label } from "../lib/api";
import { PageHeader, btn, Loading, ErrorBox, EmptyState, Badge } from "../components/kit";

export default function Notifications() {
  const r = useFetch("/me/notifications");
  const nav = useNavigate();
  const readAll = async () => { try { await api.post("/me/notifications/read-all"); toast.success("All marked as read"); r.reload(); } catch (e) { toast.error(errMsg(e)); } };
  const open = async (n) => { if (!n.read) await api.post(`/me/notifications/${n.id}/read`).catch(() => {}); if (n.link) nav(n.link); else r.reload(); };
  return (
    <>
      <PageHeader eyebrow="Notifications" title="Notifications" description="Application, proposal, mentorship, community, moderation and security updates.">
        <button className={btn("secondary")} onClick={readAll} data-testid="mark-all-read-btn">Mark all as read</button>
        <Link to="/settings?tab=notifications" className={btn("ghost")} data-testid="notification-prefs-link">Preferences</Link>
      </PageHeader>
      <div className="container-x py-8 max-w-3xl space-y-4">
        <p className="flex gap-2 rounded-lg bg-surface p-3 text-sm"><Info className="h-5 w-5 shrink-0" aria-hidden="true" />Notifications appear in-app. Email is used only for account verification and password resets; SMS and WhatsApp alerts are pending configuration.</p>
        {r.loading ? <Loading /> : r.error ? <ErrorBox message={r.error} onRetry={r.reload} /> : r.data.items.length ? (
          <ul className="space-y-2" data-testid="notifications-list">
            {r.data.items.map((n) => (
              <li key={n.id}>
                <button onClick={() => open(n)} className={`w-full text-left card p-4 hover:bg-surface ${n.read ? "" : "border-l-4 border-l-blue"}`} data-testid={`notification-${n.id}`}>
                  <div className="flex flex-wrap items-center gap-2">{!n.read && <Badge tone="blue">Unread</Badge>}<Badge tone="grey">{label(n.kind)}</Badge><span className="text-sm text-sub">{fmtDate(n.created_at)}</span></div>
                  <p className={`mt-1 ${n.read ? "" : "font-semibold"}`}>{n.title}</p>{n.body && <p className="text-sm text-sub">{n.body}</p>}
                </button>
              </li>
            ))}
          </ul>
        ) : <EmptyState icon={Bell} title="You're all caught up" body="Updates about your applications, proposals and community activity will appear here." />}
      </div>
    </>
  );
}
